"use client"

import {useEffect, useState} from "react";
import {
    Carousel,
    CarouselApi,
    CarouselContent,
    CarouselItem,
    CarouselNext,
    CarouselPrevious
} from "@/components/ui/carousel";
import {ArticleCard} from "@/components/custom/cards/articleCard";
import {Post} from "@/root/payload-types";
import {useLocale} from "@/hooks/useLocale";
import {useSystemSettings} from "@/hooks/useSystemSettings";

interface NewsCarouselProps {
    posts: Post[];
    className?: string;
    useAbsolutePath?: boolean;
}

export function NewsCarousel({ posts, className, useAbsolutePath = false }: NewsCarouselProps) {
    const [api, setApi] = useState<CarouselApi>();
    const [current, setCurrent] = useState(0);
    const [count, setCount] = useState(0);
    const locale = useLocale();
    const [ language, region ] = locale.split("-");
    const { unitSystem, scopeSystem } = useSystemSettings();

    useEffect(() => {
        if(!api) return;

        setCount(api.scrollSnapList().length);
        setCurrent(api.selectedScrollSnap() + 1);

        api.on("select", () => {
            setCurrent(api.selectedScrollSnap() + 1);
        })
    }, [api])

    return (
        <Carousel setApi={setApi} className={className} opts={{ align: "start" }}>
            <CarouselContent>
                {posts.map(post =>
                    <CarouselItem key={post.id} className={"md:basis-1/2 lg:basis-1/3"}>
                        <ArticleCard
                            bgColor={"primary"}
                            url={`${locale}/news/${post.id}`}
                            post={post}
                            useAbsolutePath={useAbsolutePath}
                        />
                    </CarouselItem>
                )}
            </CarouselContent>
            <CarouselPrevious />
            <CarouselNext />
        </Carousel>
    )
}